$(function() {
  let scrollY = $(window).scrollTop();
  $('.p-header__toggle__button').on('click', function() {
    $('.l-nav').toggleClass('js-active');
    scrollY = $(window).scrollTop();
    $('body').css({
      'position': 'fixed',
      'width': '100%',
      'top': -1 * scrollY,
    });
    return false;
  });
  $('.p-nav__close').on('click', function() {
    $('.l-nav').removeClass('js-active');
    $('#p-nav-cat').removeClass('js-active');
    $('#p-nav-brand').removeClass('js-active');
    $('body').css({
      'position': 'relative',
      'width': '',
      'top': '',
    });
    $(window).scrollTop(scrollY);
    return false;
  });

  $('.p-nav__list__item--cat').on('click', function() {
    $('#p-nav-cat').addClass('js-active');
  });
  $('.p-nav__list__item--brand').on('click', function() {
    $('#p-nav-brand').addClass('js-active');
  });
  $('.p-nav__back').on('click', function() {
    $('#p-nav-cat').removeClass('js-active');
    $('#p-nav-brand').removeClass('js-active');
  });

  // 商品詳細サイズ/アイテム詳細タブ
  $('.p-products__tabs__list li').click(function() {
    const tabIndex = $('.p-products__tabs__list li').index(this);
    $('.p-products__tabs__list li').removeClass('is-active');
    $(this).addClass('is-active');
    $('.p-products__tabs__block').removeClass('is-show').eq(tabIndex).addClass('is-show');
  });

  $('#arrivalSlider li a').each(function(index) {
    $(this).attr('href', $(this).attr('href') + '/?from=topNewArrival_' + (index + 1).toString().padStart(2, '0'));
  });
  $('#recommendSlider li a').each(function(index) {
    $(this).attr('href', $(this).attr('href') + '/?from=topRecommend_' + (index + 1).toString().padStart(2, '0'));
  });
  $('#brandRanking li a').each(function(index) {
    $(this).attr('href', $(this).attr('href') + '/?from=topRanking_' + (index + 1).toString().padStart(2, '0'));
  });
  $('#fleurItemRanking li a').each(function(index) {
    $(this).attr('href', $(this).attr('href') + '?from=itemAll_' + (index + 1).toString().padStart(2, '0'));
  });


  $('#marketing').change( function() {
    if($('#marketing').prop('checked')){
      $('.p-form__emailLang').addClass('is-active');
      $('.p-form__emailLang__check input[type="checkbox"]:nth-of-type(1)').prop('checked', true);
    } else {
      $('.p-form__emailLang').removeClass('is-active');
      $('.p-form__emailLang__check input[type="checkbox"]').prop('checked', false);
    }
  });
  //チェックボックスの複数選択を拒否
  $('.p-form__emailLang__check input[type="checkbox"]').on('click', function(){
    $('.p-form__emailLang__check input[type="checkbox"]').prop('checked', false);
    $(this).prop('checked', true);
  });


  // ページ内スクロール
  // const headerHeight = $('.l-header').innerHeight();
  // $('a[href^="#"]').click(function(){
  //   var speed = 500;
  //   var href= $(this).attr('href');
  //   var target = $(href == '"#"' || href == '""' ? 'html' : href);
  //   var position = target.offset().top - headerHeight;
  //   $('html, body').animate({scrollTop:position}, speed, 'swing');
  //   return false;
  // });

  var num_arr, extra_arr, eng_arr, html;
  var showflag = false;
  const CHARACT_NUM = 26;

  function init() {
    num_arr = [];
    extra_arr = [];
    eng_arr = [];
    html = '';
    var i = 0;
    for (i = 0; i < CHARACT_NUM; i++) {
      eng_arr[i] = new Array();
    }
  }

//////////////////////new modified////////////////////////
  function sort_data(data, list) {
    var i, j, temp;
    for (i = 0; i < data.length - 1; i++)
      for (j = i + 1; j < data.length; j++) {
        if (data[i] > data[j]) {
          temp = data[i];
          data[i] = data[j];
          data[j] = temp;
          temp = list[i];
          list[i] = list[j];
          list[j] = temp;
        }
      }
  }
///////////////////////////////////////////////////////////

  function convert() {
    if (showflag == true) return;
    init();
    var list = $.makeArray($('#brandList li a'));
    var data = [];
    var i = 0;
    for (i = 0; i < list.length; i++) {
      data.push(list[i].innerHTML);
    }
    //////////////////////new modified////////////////////////
    sort_data(data, list); //data.sort()-> sort_data(data, list)
    ///////////////////////////////////////////////////////////
    for (i = 0; i < data.length; i++) {
      var ch = data[i].charAt(0);
      if (ch >= '0' && ch <= '9')
        num_arr.push(list[i].outerHTML); //data->list modified

      else if ((ch >= 'a' && ch <= 'z') || (ch >= 'A' && ch <= 'Z')) {

        var n = 0;
        if ((ch >= 'a' && ch <= 'z'))
          n = ch.charCodeAt() - 'a'.charCodeAt();
        else n = ch.charCodeAt() - 'A'.charCodeAt();
        eng_arr[n].push(list[i].outerHTML); //data->list modified

      } else extra_arr.push(list[i].outerHTML); //data->list modified
    }

    html += getEnglish();
    html += getNumber();
    html += getExtra();
    $('.p-gnav__initials').append(html);
    showflag = true;
  }

  function getNumber() {
    var num_txt = '<li class=\'p-gnav__initials__item\'>0~9<div class=\'p-gnav__initials__content\'><ul class=\'p-gnav__content__list\'>';
    $.map(num_arr, function(item) {
      num_txt += '<li>';
      num_txt += item;
      num_txt += '</li>';
    })
    num_txt += '</ul></div></li>';
    return num_txt;
  }

  function getExtra() {
    var extra_txt = '<li class=\'p-gnav__initials__item\'>その他<div class=\'p-gnav__initials__content\'><ul class=\'p-gnav__content__list\'>';
    $.map(extra_arr, function(item) {
      extra_txt += '<li>';
      extra_txt += item;
      extra_txt += '</li>';
    })
    extra_txt += '</ul></div></li>';
    return extra_txt;
  }

  function getEnglish() {
    var eng_txt = '';
    for (var i = 0; i < CHARACT_NUM; i++) {
      if (eng_arr[i].length == 0) continue;
      else {
        eng_txt += '<li class=\'p-gnav__initials__item\'>' + (String.fromCharCode(65 + i)) + '<div class=\'p-gnav__initials__content\'><ul class=\'p-gnav__content__list\'>';

        $.map(eng_arr[i], function(item) {
          eng_txt += '<li>';
          eng_txt += item;
          eng_txt += '</li>';
        })
        eng_txt += '</ul></li>'
      }
    }
    return eng_txt;
  }
  convert();
  $('#brandList').remove();
  $('.p-gnav__initials__item:first-child').addClass('js-active');
  $('.p-gnav__initials__item:first-child').children('.p-gnav__initials__content').addClass('js-show');

  const tabs = $('.p-gnav__initials__item');
  function tabSwitch() {
    $('.js-active').removeClass('js-active');
    $(this).addClass('js-active');
    const index = tabs.index(this);
    $('.p-gnav__initials__content').removeClass('js-show').eq(index).addClass('js-show');
  }
  tabs.hover(tabSwitch);


  // アコーディオンのタイトルがクリックされたら
  $(function() {
    $('.p-qanda__answer').hide();
    $('.p-qanda__question').click(function() {
      $(this).next().slideToggle();
      $('span', this).next().toggle(300);
      // hrefにページ遷移しない
      return false;
    });
  });

  //高さを整える
  var windowWidth = $(window).width();
  var breakPoint = 750;

  // function sending_iconHeight() {
  //   var maxHeight = 0;
  //   if (windowWidth > breakPoint) {
  //     //もしdivがmaxHeightの値より大きい場合は.js-service-headlineの高さを全部合わせる
  //     $('.js-iconHeight').each(function() {
  //       if ($(this).height() > maxHeight) {
  //         maxHeight = $(this).height();
  //       }
  //     });
  //     //.js-service-headlineの高さを取得する
  //     $('.js-iconHeight').height(maxHeight);
  //   }
  // }
  //
  // function sending_timeHeight() {
  //   var maxHeight = 0;
  //   if (windowWidth > breakPoint) {
  //     $('.p-sending__time').each(function() {
  //       if ($(this).height() > maxHeight) {
  //         maxHeight = $(this).height();
  //       }
  //     });
  //     $('.p-sending__time').height(maxHeight);
  //   }
  // }
  // //初回実行
  // sending_iconHeight();
  // sending_timeHeight();
  //
  // //画面幅が変更させれた実行
  // $(window).resize(function() {
  //   sending_iconHeight();
  //   sending_timeHeight();
  // });

//スムーズスクロール
//   $(function(){
//     $('a[href^="#"]').click(function(){
//       let speed = 500;
//       let href= $(this).attr('href');
//       let target = $(href == '#' || href == '' ? 'html' : href);
//       let position = target.offset().top;
//       $('html, body').animate({scrollTop:position}, speed, 'swing');
//       return false;
//     });
//   });

  //モーダル
  $(function () {
    $('.c-modal__open').click(function () {
      $('.c-modal__overlay, .c-modal__window').fadeIn();
      if (windowWidth < breakPoint){
        $('.c-modal__window').css('display','flex');
      }
    });

    $('.c-modal__close').click(function () {
      $('.c-modal__overlay, .c-modal__window').fadeOut();
    });
  });

  var $text = $('.p-collectionHero__desc span');//対象のテキスト
  var $more = $('.p-collectionHero__more');//続きを読むボタン
  //var lineNum = 2;//表示する行数
  var textHeight = $text.height();//テキスト全文の高さ
  //var lineHeight = parseFloat($text.css('line-height'));//line-height
  //var textNewHeight = lineHeight * lineNum;//指定した行数までのテキストの高さ
  // テキストが表示制限の行数を超えたら発動
  if (textHeight > 34) {
    //続きを読むボタンクリックで全文表示
    $more.click(function () {
      $(this).hide();
      $('.p-collectionHero__desc').addClass('js-active');
      return false;//aタグ無効化
    });
  } else {
    // 指定した行数以下のテキストなら続きを読むは表示しない
    $more.hide();
  }

  //商品詳細ページ
  setTimeout(function(){
    if($('.product-single__form').hasClass('gPreorderDiscountForm')){
      $('.p-products__fix').addClass('js-reserved');
    }
  },0);




  var num_arrSp, extra_arrSp, eng_arrSp, htmlSp;
  var showflagSp = false;
  const CHARACT_NUM_SP = 26;

  function initSp() {
    num_arrSp = [];
    extra_arrSp = [];
    eng_arrSp = [];
    htmlSp = '';
    var i = 0;
    for (i = 0; i < CHARACT_NUM_SP; i++) {
      eng_arrSp[i] = new Array();
    }
  }

//////////////////////new modified////////////////////////
  function sort_dataSp(data, list) {
    var i, j, temp;
    for (i = 0; i < data.length - 1; i++)
      for (j = i + 1; j < data.length; j++) {
        if (data[i] > data[j]) {
          temp = data[i];
          data[i] = data[j];
          data[j] = temp;
          temp = list[i];
          list[i] = list[j];
          list[j] = temp;
        }
      }
  }
///////////////////////////////////////////////////////////

  function convertSp() {
    if (showflagSp == true) return;
    initSp();
    var list = $.makeArray($('#spBrandList li a'));
    var data = [];
    var i = 0;
    for (i = 0; i < list.length; i++) {
      data.push(list[i].innerHTML);
    }
    //////////////////////new modified////////////////////////
    sort_dataSp(data, list); //data.sort()-> sort_data(data, list)
    ///////////////////////////////////////////////////////////
    for (i = 0; i < data.length; i++) {
      var ch = data[i].charAt(0);
      if (ch >= '0' && ch <= '9')
        num_arrSp.push(list[i].outerHTML); //data->list modified

      else if ((ch >= 'a' && ch <= 'z') || (ch >= 'A' && ch <= 'Z')) {

        var n = 0;
        if ((ch >= 'a' && ch <= 'z'))
          n = ch.charCodeAt() - 'a'.charCodeAt();
        else n = ch.charCodeAt() - 'A'.charCodeAt();
        eng_arrSp[n].push(list[i].outerHTML); //data->list modified

      } else extra_arrSp.push(list[i].outerHTML); //data->list modified
    }

    htmlSp += getEnglishSp();
    htmlSp += getNumberSp();
    htmlSp += getExtraSp();
    $('#spBrandListOutput').append(htmlSp);
    showflagSp = true;
  }

  function getNumberSp() {
    var num_txtSp = '<dl class=\'p-nav__brandInitial\'><dt>0~9</dt><dd>';
    $.map(num_arrSp, function(item) {
      num_txtSp += item;
    })
    num_txtSp += '</dd></dl>';
    return num_txtSp;
  }

  function getExtraSp() {
    var extra_txtSp = '<dl class=\'p-nav__brandInitial\'><dt>その他</dt><dd>';
    $.map(extra_arrSp, function(item) {
      extra_txtSp += item;
    })
    extra_txtSp += '</dd></dl>';
    return extra_txtSp;
  }

  function getEnglishSp() {
    var eng_txtSp = '';
    for (var i = 0; i < CHARACT_NUM_SP; i++) {
      if (eng_arrSp[i].length == 0) continue;
      else {
        eng_txtSp += '<dl class=\'p-nav__brandInitial\'><dt>' + (String.fromCharCode(65 + i)) + '</dt><dd>';

        $.map(eng_arrSp[i], function(item) {
          eng_txtSp += item;
        })
        eng_txtSp += '</dd></dl>'
      }
    }
    return eng_txtSp;
  }
  convertSp();
  $('#spBrandList').remove();

  $('.p-nav__brandInitial dt').on('click', function(){
    $(this).next().slideToggle();
  })

});
